import { bigintHash, comparePrimitives, defaultOf, compare } from "./fable_modules/fable-library-js.4.29.0/Util.js";
import { toArray, defaultArg, some, value as value_1 } from "./fable_modules/fable-library-js.4.29.0/Option.js";
import { equalsWith, map as map_4, append, collect, item as item_3 } from "./fable_modules/fable-library-js.4.29.0/Array.js";
import { Option_defaultOrMap } from "./Model/Prelude.js";
import { FSharpRef, Record, Union } from "./fable_modules/fable-library-js.4.29.0/Types.js";
import { list_type, int64_type, enum_type, int32_type, option_type, tuple_type, bool_type, string_type, uint32_type, record_type, class_type, union_type } from "./fable_modules/fable-library-js.4.29.0/Reflection.js";
import { tryFind, ofSeq, FSharpMap__get_Item, empty } from "./fable_modules/fable-library-js.4.29.0/Map.js";
import { ofArray, ofSeq as ofSeq_1, FSharpSet__Contains, empty as empty_1 } from "./fable_modules/fable-library-js.4.29.0/Set.js";
import { contains, choose, map as map_3 } from "./fable_modules/fable-library-js.4.29.0/Seq.js";
import { CropModule_canGetOwnSeedsFromSeedMaker, CropModule_makesOwnSeeds, CropModule_items, CropModule_isForage, CropModule_seed } from "./Model/Crops.js";
import { ProductModule_processor } from "./Model/Items.js";
import { GameData_$reflection, GameVariables_$reflection, GameDataModule_products } from "./Model/Game.js";
import { getItemFromDict } from "./fable_modules/fable-library-js.4.29.0/MapUtil.js";
import { equals } from "./fable_modules/fable-library-js.4.29.0/BigInt.js";
import { tryParse } from "./fable_modules/fable-library-js.4.29.0/Int32.js";
import { split } from "./fable_modules/fable-library-js.4.29.0/String.js";
import { map as map_5 } from "./fable_modules/fable-library-js.4.29.0/List.js";

export const Util_console = console;

export function Util_minBy(projection, a, b) {
    if (compare(projection(a), projection(b)) <= 0) {
        return a;
    }
    else {
        return b;
    }
}

export function Util_maxBy(projection, a, b) {
    if (compare(projection(a), projection(b)) >= 0) {
        return a;
    }
    else {
        return b;
    }
}

export function Util_compareBy(projection, a, b) {
    return compare(projection(a), projection(b));
}

export function Util_compareByDirection(projection, ascending) {
    if (ascending) {
        return (a) => ((b) => Util_compareBy(projection, a, b));
    }
    else {
        return (a_1) => ((b_1) => Util_compareBy(projection, b_1, a_1));
    }
}

export function Util_refMemo(f) {
    let prevInput = defaultOf();
    let prevOutput = defaultOf();
    return (x) => {
        if (!(x === prevInput)) {
            prevInput = x;
            prevOutput = f(x);
        }
        return prevOutput;
    };
}

export function Option_merge(merger, a, b) {
    if (a == null) {
        if (b == null) {
            return undefined;
        }
        else {
            const b_2 = value_1(b);
            return some(b_2);
        }
    }
    else if (b == null) {
        const a_2 = value_1(a);
        return some(a_2);
    }
    else {
        const a_1 = value_1(a);
        const b_1 = value_1(b);
        return some(merger(a_1, b_1));
    }
}

/**
 * Compares two options, treating `None` as the max value instead of the min value.
 */
export function Option_noneMaxCompare(a, b) {
    if (a != null) {
        if (b != null) {
            const a_1 = value_1(a);
            const b_1 = value_1(b);
            return compare(a_1, b_1) | 0;
        }
        else {
            return -1;
        }
    }
    else if (b != null) {
        return 1;
    }
    else {
        return 0;
    }
}

export function Option_noneMaxCompareBy(projection, a, b) {
    return Option_noneMaxCompare(projection(a), projection(b));
}

export function Option_ofResult(_arg) {
    if (_arg.tag === 1) {
        return undefined;
    }
    else {
        return some(_arg.fields[0]);
    }
}

export function Result_get(_arg) {
    if (_arg.tag === 1) {
        throw new Error("The result value was Error.\\nParameter name: result");
    }
    else {
        return _arg.fields[0];
    }
}

export function Result_defaultValue(defaultValue, _arg) {
    if (_arg.tag === 1) {
        return defaultValue;
    }
    else {
        return _arg.fields[0];
    }
}

export function Result_isOk(_arg) {
    if (_arg.tag === 1) {
        return false;
    }
    else {
        return true;
    }
}

export function Result_isError(_arg) {
    if (_arg.tag === 1) {
        return true;
    }
    else {
        return false;
    }
}

export function Array_mapReduce(reduction, mapping, array) {
    if (array.length === 0) {
        throw new Error("The given array cannot be empty.\\nParameter name: array");
    }
    let current = mapping(item_3(0, array));
    for (let idx = 0; idx <= (array.length - 1); idx++) {
        const x = item_3(idx, array);
        current = reduction(current, mapping(x));
    }
    return current;
}

export function Array_map2Reduce(reduction, mapping, array1, array2) {
    const len = array1.length | 0;
    if (len !== array2.length) {
        throw new Error("The given arrays had different lengths.\\nParameter name: array1");
    }
    if (len === 0) {
        throw new Error("The given arrays cannot be empty.\\nParameter name: array1");
    }
    let current = mapping(item_3(0, array1), item_3(0, array2));
    for (let i = 1; i <= (len - 1); i++) {
        current = reduction(current, mapping(item_3(i, array1), item_3(i, array2)));
    }
    return current;
}

export const Fertilizer_Opt_displayName = (_arg_1) => Option_defaultOrMap("No Fertilizer", (_arg) => _arg.Name, _arg_1);

export class CustomChoice$2 extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NonCustom", "Custom"];
    }
}

export function CustomChoice$2_$reflection(gen0, gen1) {
    return union_type("StardewValleyStonks.WebApp.CustomChoice`2", [gen0, gen1], CustomChoice$2, () => [[["Item", gen0]], [["Item", gen1]]]);
}

export class Selection$2 extends Record {
    constructor(Values, Selected) {
        super();
        this.Values = Values;
        this.Selected = Selected;
    }
}

export function Selection$2_$reflection(gen0, gen1) {
    return record_type("StardewValleyStonks.WebApp.Selection`2", [gen0, gen1], Selection$2, () => [["Values", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [gen0, gen1])], ["Selected", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [gen0])]]);
}

export function Selection_empty() {
    return new Selection$2(empty({
        Compare: compare,
    }), empty_1({
        Compare: compare,
    }));
}

export function Selection_selectedValue(key, selection) {
    if (FSharpSet__Contains(selection.Selected, key)) {
        return some(FSharpMap__get_Item(selection.Values, key));
    }
    else {
        return undefined;
    }
}

export class Selections extends Record {
    constructor(Crops, SeedPrices, NoFertilizer, Fertilizers, FertilizerPrices, SellRaw, Products, UseHarvestedSeeds, UseSeedMaker, UseForageSeeds, CustomSeedPrices, CustomFertilizerPrices, CustomSellPrices) {
        super();
        this.Crops = Crops;
        this.SeedPrices = SeedPrices;
        this.NoFertilizer = NoFertilizer;
        this.Fertilizers = Fertilizers;
        this.FertilizerPrices = FertilizerPrices;
        this.SellRaw = SellRaw;
        this.Products = Products;
        this.UseHarvestedSeeds = UseHarvestedSeeds;
        this.UseSeedMaker = UseSeedMaker;
        this.UseForageSeeds = UseForageSeeds;
        this.CustomSeedPrices = CustomSeedPrices;
        this.CustomFertilizerPrices = CustomFertilizerPrices;
        this.CustomSellPrices = CustomSellPrices;
    }
}

export function Selections_$reflection() {
    return record_type("StardewValleyStonks.WebApp.Selections", [], Selections, () => [["Crops", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [uint32_type])], ["SeedPrices", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [uint32_type, class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])])], ["NoFertilizer", bool_type], ["Fertilizers", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])], ["FertilizerPrices", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])])], ["SellRaw", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [uint32_type])], ["Products", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [uint32_type, class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])])], ["UseHarvestedSeeds", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [uint32_type])], ["UseSeedMaker", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [uint32_type])], ["UseForageSeeds", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [uint32_type])], ["CustomSeedPrices", Selection$2_$reflection(uint32_type, uint32_type)], ["CustomFertilizerPrices", Selection$2_$reflection(string_type, uint32_type)], ["CustomSellPrices", Selection$2_$reflection(uint32_type, tuple_type(uint32_type, bool_type))]]);
}

function SelectionsModule_ensureMapEntries(keys, map) {
    return ofSeq(map_3((key) => [key, defaultArg(tryFind(key, map), empty_1({
        Compare: compare,
    }))], keys), {
        Compare: compare,
    });
}

export function SelectionsModule_ensureEntries(data, selected) {
    return new Selections(selected.Crops, SelectionsModule_ensureMapEntries(data.Crops.fields[0].keys(), selected.SeedPrices), selected.NoFertilizer, selected.Fertilizers, SelectionsModule_ensureMapEntries(data.Fertilizers.fields[0].keys(), selected.FertilizerPrices), selected.SellRaw, SelectionsModule_ensureMapEntries(data.Items.fields[0].keys(), selected.Products), selected.UseHarvestedSeeds, selected.UseSeedMaker, selected.UseForageSeeds, selected.CustomSeedPrices, selected.CustomFertilizerPrices, selected.CustomSellPrices);
}

function SelectionsModule_mapOfSets(table) {
    return ofSeq(map_3((tupledArg) => [tupledArg[0], ofSeq_1(tupledArg[1].fields[0].keys(), {
        Compare: compare,
    })], table.fields[0]), {
        Compare: compare,
    });
}

export function SelectionsModule_createAllSelected(data) {
    const seedSet = (predicate) => ofSeq_1(choose((crop) => {
        if (predicate(crop)) {
            return CropModule_seed(crop);
        }
        else {
            return undefined;
        }
    }, data.Crops.fields[0].values()), {
        Compare: comparePrimitives,
    });
    const forageCrops = seedSet(CropModule_isForage);
    let items;
    const array_2 = collect(CropModule_items, Array.from(data.Crops.fields[0].values()), Uint32Array);
    items = append(Uint32Array.from(map_3((seed) => (seed * 1), forageCrops)), array_2, Uint32Array);
    return new Selections(ofSeq_1(data.Crops.fields[0].keys(), {
        Compare: comparePrimitives,
    }), SelectionsModule_mapOfSets(data.SeedPrices), true, ofSeq_1(data.Fertilizers.fields[0].keys(), {
        Compare: comparePrimitives,
    }), SelectionsModule_mapOfSets(data.FertilizerPrices), ofArray(items, {
        Compare: comparePrimitives,
    }), ofSeq(map_3((item) => [item, ofArray(map_4(ProductModule_processor, GameDataModule_products(data, item)), {
        Compare: comparePrimitives,
    })], items), {
        Compare: comparePrimitives,
    }), seedSet(CropModule_makesOwnSeeds), seedSet((crop_2) => CropModule_canGetOwnSeedsFromSeedMaker((key) => getItemFromDict(data.Items.fields[0], key), crop_2)), forageCrops, Selection_empty(), Selection_empty(), Selection_empty());
}

export class SeedStrategy extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Buy First", "Stockpile", "Ignore"];
    }
}

export function SeedStrategy_$reflection() {
    return union_type("StardewValleyStonks.WebApp.SeedStrategy", [], SeedStrategy, () => [[], [], []]);
}

export class ProfitSettings extends Record {
    constructor(SeedStrategy, PayForFertilizer, PayForDestroyedFertilizer) {
        super();
        this.SeedStrategy = SeedStrategy;
        this.PayForFertilizer = PayForFertilizer;
        this.PayForDestroyedFertilizer = PayForDestroyedFertilizer;
    }
}

export function ProfitSettings_$reflection() {
    return record_type("StardewValleyStonks.WebApp.ProfitSettings", [], ProfitSettings, () => [["SeedStrategy", SeedStrategy_$reflection()], ["PayForFertilizer", bool_type], ["PayForDestroyedFertilizer", bool_type]]);
}

export class Settings extends Record {
    constructor(Game, Profit, Selected) {
        super();
        this.Game = Game;
        this.Profit = Profit;
        this.Selected = Selected;
    }
}

export function Settings_$reflection() {
    return record_type("StardewValleyStonks.WebApp.Settings", [], Settings, () => [["Game", GameVariables_$reflection()], ["Profit", ProfitSettings_$reflection()], ["Selected", Selections_$reflection()]]);
}

export function SettingsModule_ensureEntries(data, settings) {
    return new Settings(settings.Game, settings.Profit, SelectionsModule_ensureEntries(data, settings.Selected));
}

export class AppMode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Ranker", "Optimizer"];
    }
}

export function AppMode_$reflection() {
    return union_type("StardewValleyStonks.WebApp.AppMode", [], AppMode, () => [[], []]);
}

export class RankItem extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["All Pairs", "Crops", "Fertilizers"];
    }
}

export function RankItem_$reflection() {
    return union_type("StardewValleyStonks.WebApp.RankItem", [], RankItem, () => [[], [], []]);
}

export class RankMetric extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Gold", "ROI", "XP"];
    }
}

export function RankMetric_$reflection() {
    return union_type("StardewValleyStonks.WebApp.RankMetric", [], RankMetric, () => [[], [], []]);
}

export function RankMetricModule_unit(_arg) {
    switch (_arg.tag) {
        case 1:
            return "%";
        case 2:
            return "xp";
        default:
            return "g";
    }
}

export class TimeNormalization extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Total", "Per Day", "Per Season"];
    }
}

export function TimeNormalization_$reflection() {
    return union_type("StardewValleyStonks.WebApp.TimeNormalization", [], TimeNormalization, () => [[], [], []]);
}

export function TimeNormalizationModule_unit(_arg) {
    switch (_arg.tag) {
        case 1:
            return "day";
        case 2:
            return "season";
        default:
            return "";
    }
}

export class Ranker extends Record {
    constructor(RankItem, RankMetric, TimeNormalization, ShowInvalid, BrushSpan, SelectedCropAndFertilizer) {
        super();
        this.RankItem = RankItem;
        this.RankMetric = RankMetric;
        this.TimeNormalization = TimeNormalization;
        this.ShowInvalid = ShowInvalid;
        this.BrushSpan = BrushSpan;
        this.SelectedCropAndFertilizer = SelectedCropAndFertilizer;
    }
}

export function Ranker_$reflection() {
    return record_type("StardewValleyStonks.WebApp.Ranker", [], Ranker, () => [["RankItem", RankItem_$reflection()], ["RankMetric", RankMetric_$reflection()], ["TimeNormalization", TimeNormalization_$reflection()], ["ShowInvalid", bool_type], ["BrushSpan", tuple_type(uint32_type, uint32_type)], ["SelectedCropAndFertilizer", option_type(tuple_type(option_type(uint32_type), option_type(option_type(string_type))))]]);
}

export class OptimizationObjective extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Gold", "XP"];
    }
}

export function OptimizationObjective_$reflection() {
    return union_type("StardewValleyStonks.WebApp.OptimizationObjective", [], OptimizationObjective, () => [[], []]);
}

export class SettingsTab extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Crops", "Fertilizers", "Misc", "Load/Save"];
    }
}

export function SettingsTab_$reflection() {
    return union_type("StardewValleyStonks.WebApp.SettingsTab", [], SettingsTab, () => [[], [], [], []]);
}

export class OpenDetails extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["CropFilters", "Crops", "Products", "Seeds", "Fertilizers", "FertilizerPrices", "Skills", "Multipliers", "CropSettings", "Mod", "RankerGrowthCalendar", "RankerSummary", "OptimizerGrowthCalendar", "OptimizerSummary"];
    }
}

export function OpenDetails_$reflection() {
    return union_type("StardewValleyStonks.WebApp.OpenDetails", [], OpenDetails, () => [[], [], [], [], [], [], [], [], [], [], [], [], [], []]);
}

export class CropFilters extends Record {
    constructor(ItemNameSearch, InSeason, Seasons, Regrows, Giant, Forage) {
        super();
        this.ItemNameSearch = ItemNameSearch;
        this.InSeason = InSeason;
        this.Seasons = (Seasons | 0);
        this.Regrows = Regrows;
        this.Giant = Giant;
        this.Forage = Forage;
    }
}

export function CropFilters_$reflection() {
    return record_type("StardewValleyStonks.WebApp.CropFilters", [], CropFilters, () => [["ItemNameSearch", string_type], ["InSeason", bool_type], ["Seasons", enum_type("StardewValleyStonks.Seasons", int32_type, [["None", 0], ["Spring", 1], ["Summer", 2], ["Fall", 4], ["Winter", 8], ["All", 15]])], ["Regrows", option_type(bool_type)], ["Giant", option_type(bool_type)], ["Forage", option_type(bool_type)]]);
}

export const CropFiltersModule_empty = new CropFilters("", true, 0, undefined, undefined, undefined);

export class CropTabState extends Record {
    constructor(Filters, CropSort, ProductSort, SeedSort, ProductQuality, NormalizeProductPrices) {
        super();
        this.Filters = Filters;
        this.CropSort = CropSort;
        this.ProductSort = ProductSort;
        this.SeedSort = SeedSort;
        this.ProductQuality = (ProductQuality | 0);
        this.NormalizeProductPrices = NormalizeProductPrices;
    }
}

export function CropTabState_$reflection() {
    return record_type("StardewValleyStonks.WebApp.CropTabState", [], CropTabState, () => [["Filters", CropFilters_$reflection()], ["CropSort", tuple_type(uint32_type, bool_type)], ["ProductSort", tuple_type(uint32_type, bool_type)], ["SeedSort", tuple_type(uint32_type, bool_type)], ["ProductQuality", enum_type("StardewValleyStonks.Quality", int32_type, [["Normal", 0], ["Silver", 1], ["Gold", 2], ["Iridium", 3]])], ["NormalizeProductPrices", bool_type]]);
}

export class UIState extends Record {
    constructor(Mode, Ranker, OptimizationObjective, SettingsTab, OpenDetails, CropTab, FertilizerSort, FertilizerPriceSort) {
        super();
        this.Mode = Mode;
        this.Ranker = Ranker;
        this.OptimizationObjective = OptimizationObjective;
        this.SettingsTab = SettingsTab;
        this.OpenDetails = OpenDetails;
        this.CropTab = CropTab;
        this.FertilizerSort = FertilizerSort;
        this.FertilizerPriceSort = FertilizerPriceSort;
    }
}

export function UIState_$reflection() {
    return record_type("StardewValleyStonks.WebApp.UIState", [], UIState, () => [["Mode", AppMode_$reflection()], ["Ranker", Ranker_$reflection()], ["OptimizationObjective", OptimizationObjective_$reflection()], ["SettingsTab", SettingsTab_$reflection()], ["OpenDetails", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [OpenDetails_$reflection()])], ["CropTab", CropTabState_$reflection()], ["FertilizerSort", tuple_type(uint32_type, bool_type)], ["FertilizerPriceSort", tuple_type(uint32_type, bool_type)]]);
}

export class Preset extends Record {
    constructor(Name, UniqueId, Settings) {
        super();
        this.Name = Name;
        this.UniqueId = UniqueId;
        this.Settings = Settings;
    }
}

export function Preset_$reflection() {
    return record_type("StardewValleyStonks.WebApp.Preset", [], Preset, () => [["Name", string_type], ["UniqueId", option_type(int64_type)], ["Settings", Settings_$reflection()]]);
}

export function PresetModule_hasId(uniqueId, preset) {
    return contains(uniqueId, toArray(preset.UniqueId), {
        Equals: equals,
        GetHashCode: bigintHash,
    });
}

export class App extends Record {
    constructor(Data, Presets, State) {
        super();
        this.Data = Data;
        this.Presets = Presets;
        this.State = State;
    }
}

export function App_$reflection() {
    return record_type("StardewValleyStonks.WebApp.App", [], App, () => [["Data", GameData_$reflection()], ["Presets", list_type(Preset_$reflection())], ["State", tuple_type(Settings_$reflection(), UIState_$reflection())]]);
}

export class Version extends Record {
    constructor(Major, Minor, Patch) {
        super();
        this.Major = Major;
        this.Minor = Minor;
        this.Patch = Patch;
    }
    toString() {
        const this$ = this;
        return `${this$.Major}.${this$.Minor}.${this$.Patch}`;
    }
}

export function Version_$reflection() {
    return record_type("StardewValleyStonks.WebApp.Version", [], Version, () => [["Major", uint32_type], ["Minor", uint32_type], ["Patch", uint32_type]]);
}

function VersionModule_$007CNat$007C_$007C(str) {
    let matchValue;
    let outArg = 0;
    matchValue = [tryParse(str, 511, true, 32, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
    if (matchValue[0]) {
        return matchValue[1];
    }
    else {
        return undefined;
    }
}

export function VersionModule_tryParse(str) {
    const matchValue = split(str, ["."], undefined, 0);
    let matchResult, major, minor, patch;
    if (!equalsWith((x, y) => (x === y), matchValue, defaultOf()) && (matchValue.length === 3)) {
        const activePatternResult = VersionModule_$007CNat$007C_$007C(item_3(0, matchValue));
        if (activePatternResult != null) {
            const activePatternResult_1 = VersionModule_$007CNat$007C_$007C(item_3(1, matchValue));
            if (activePatternResult_1 != null) {
                const activePatternResult_2 = VersionModule_$007CNat$007C_$007C(item_3(2, matchValue));
                if (activePatternResult_2 != null) {
                    matchResult = 0;
                    major = activePatternResult;
                    minor = activePatternResult_1;
                    patch = activePatternResult_2;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return new Version(major, minor, patch);
        default:
            return undefined;
    }
}

export const AppModule_version = value_1(VersionModule_tryParse("1.0.0"));

export function AppModule_ensureEntries(data, app) {
    const patternInput = app.State;
    const settings = patternInput[0];
    const State = [SettingsModule_ensureEntries(data, settings), patternInput[1]];
    return new App(data, map_5((preset) => (new Preset(preset.Name, preset.UniqueId, SettingsModule_ensureEntries(data, settings))), app.Presets), State);
}

//# sourceMappingURL=Types.js.map
